<template>
  <div class="liveset">
    <div class="mgt-22">当对接跳转到观看页或者直播控制台的页面时，<span class="red">如果页面提示无权限</span>，通常是token计算错误，以下是关于两个跳转页面所需要的token的计算说明，请进行对比验证：</div>
    <el-form ref="form" label-width="100px" class="demo-ruleForm">
      <el-form-item label="当前日期:" required>
        <el-input v-model="form.nowtTme" disabled></el-input>
      </el-form-item>
      <div class="mgt-22">
        <div class="mgt-22"> 1.观看页对接调用接口 /v1/user/watch_from_app_xcx/ </div>
        <div class="mgt-22">
          <div class="mgt-22">参数 <span class="red">auth_token</span> md5计算示例如下:</div>
          <div style="padding-left: 10px;margin-bottom: 10px">
            <span> 注意:</span>
            <span class="red">md5(secret+当前日期+userid)</span>
            如今天 2022.4.19，userid为23981，secret为qwue23fufeaf32eert，则计算md5(qwue23fufeaf32eert2022041923981)=2f46e43d2defab58cd7c61352b96af40，可以在
            <a href="http://www.ip33.com/md5.html" target="_blank"
              >http://www.ip33.com/md5.html</a
            >进行在线验算
          </div>
          <div class="red mgt-22" style="padding-left: 10px;">
            通过前端操作md5来计算有风险,容易暴露auth_token和Secret,尽量通过后端来处理计算这个auth_token,这里只是为了演示比较方便
          </div>
          <el-form-item label="Secret:">
            <el-input v-model="obj.secret"></el-input>
          </el-form-item>
          <el-form-item label="用户id:">
            <el-input v-model="obj.user_id" placeholder="请填写请填写用户id (对接方)"></el-input>
          </el-form-item>
          <el-form-item label="auth_token:">
            <el-input v-model="obj.auth_token" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getSecretToken">获取auth_token</el-button>
          </el-form-item>
        </div>
      </div>
      <div class="mgt-22">
        <div class="mgt-22"> 2.直播管理系统对接调用接口 /v1/base/back/stream_away/ </div>
        <div class="mgt-22">
          <div class="mgt-22">参数 <span class="red">auth_token</span> md5计算示例如下:</div>
          <div class="mgt-22" style="padding-left: 10px">
            <span> 注意:</span>
            <span class="red">当前日期+streamvideo+enterprise_id</span>
            做md5处理，如当前日期2022年4月19日，企业id为588，则md5(20220419streamvideo588)=3e30f9e681195a6c76cec48709a8f34d,可以做网站
            <a href="http://www.ip33.com/md5.html" target="_blank"
              >http://www.ip33.com/md5.html</a
            >做验证
          </div>
          <el-form-item label="streamvideo:">
            <el-input v-model="form.streamvideo" disabled></el-input>
          </el-form-item>
          <el-form-item label="企业id:">
            <el-input v-model="form.enterprise_id" placeholder="请填写企业id"></el-input>
          </el-form-item>
          <el-form-item label="auth_token:">
            <el-input v-model="form.auth_token" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getStreamToken">获取auth_token</el-button>
          </el-form-item>
        </div>
        <div class="mgt-22">
          <div class="mgt-22">参数 <span class="red">user_token</span> md5计算示例如下:</div>
          <div class="mgt-22" style="padding-left: 10px">
            <span> 注意:</span>
            <span class="red">当前日期+registuser+用户ID(对接方)</span>做md5处理
          </div>
          <el-form-item label="registuser:">
            <el-input v-model="form.registuser" disabled></el-input>
          </el-form-item>
          <el-form-item label="用户id:">
            <el-input v-model="form.user_id" placeholder="请填写用户id (对接方)"></el-input>
          </el-form-item>
          <el-form-item label="user_token:">
            <el-input v-model="form.user_token" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getRegistuserToken">获取user_token</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <!-- 直播管理系统对接 auth_token -->
    <el-dialog title="auth_token" :visible.sync="streamAuthVisible" width="50%">
      <streamToken ref="streamToken" :streamData="form"></streamToken>
    </el-dialog>
    <!-- 直播管理系统对接 user_token -->
    <el-dialog title="user_token" :visible.sync="registuserUserVisible" width="50%">
      <registToken ref="registToken" :registData="form"></registToken>
    </el-dialog>
    <!-- 观看页对接 auth_token -->
    <el-dialog title="auth_token" :visible.sync="secretAuthVisible" width="50%">
      <secretToken ref="secretToken" :secretData="obj"></secretToken>
    </el-dialog>
  </div>
</template>
<script>
// 导入组件
import streamToken from "./streamAuthtoken.vue"
import registToken from "./registUsertoken.vue"
import secretToken from "./secretToken.vue"
export default {
  components: {
    streamToken,
    registToken,
    secretToken
  },
  data() {
    return {
      form: {
        nowtTme: "", // 当前日期
        streamvideo: "streamvideo", // 默认
        enterprise_id: "", // 企业id
        auth_token: "", // 授权token
        registuser:"registuser",  //
        user_id:"",     //  用户id (对接方)
        user_token:"",  // 用户token
      },
      obj:{
        secret:'64a4c75ab3a63b1238f8c31aaa74bbc6',     //  商户密钥
        user_id:"",     //  用户id (对接方)
        auth_token:'',  //   授权token
        nowtTme: "", // 当前日期
      },
      streamAuthVisible: false, // 直播管理系统auth_token弹框
      registuserUserVisible: false,  // 直播管理系统user_token弹框
      secretAuthVisible: false,   // 观看页auth_token弹框
    };
  },
  created() {
    this.getTime();
  },
  methods: {
    // 获取当前年月日
    getTime() {
      let nowData = "";
      let date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      nowData = y+ '' + m + ''+ d;
      this.form.nowtTme = nowData;
      this.obj.nowtTme = nowData;
    },
    // 打开直播管理系统对接处理auth_token弹框和auth_token展示
    getStreamToken(){
      if (!this.form.enterprise_id) {
        this.$message({
          message: "请填写企业id",
          type: "warning"
        });
        return;
      }
      this.form.auth_token = this.$md5(this.form.nowtTme + this.form.streamvideo + this.form.enterprise_id);

      setTimeout(() => {
        this.streamAuthVisible = true
        this.$nextTick(() => {
          this.$refs.streamToken.getData(); // 触发弹框页面的方法来传递数据
        });
      }, 1000);

    },
    // 打开直播管理系统对接处理user_token弹框和user_token展示
    getRegistuserToken(){
      if (!this.form.user_id) {
        this.$message({
          message: "请填写直播管理系统对接方的用户id",
          type: "warning"
        });
        return;
      }
      this.form.user_token = this.$md5(this.form.nowtTme + this.form.registuser + this.form.user_id)

      setTimeout(() => {
        this.registuserUserVisible = true
        this.$nextTick(() => {
          this.$refs.registToken.getData(); // 触发弹框页面的方法来传递数据
        });
      }, 1000);
    },
    // 打开观看页对接处理auth_token弹框和auth_token展示
    getSecretToken(){
      if (!this.obj.secret) {
        this.$message({
          message: "请填写Secret",
          type: "warning"
        });
        return;
      }
      if (!this.obj.user_id) {
        this.$message({
          message: "请填写观看页对接方的用户id",
          type: "warning"
        });
        return;
      }



      this.obj.auth_token = this.$md5(this.obj.secret + this.obj.nowtTme + this.obj.user_id)

      setTimeout(() => {
        this.secretAuthVisible = true
        this.$nextTick(() => {
          this.$refs.secretToken.getData(); // 触发弹框页面的方法来传递数据
        });
      }, 1000);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input {
  width: 500px !important;
}
/deep/ .el-upload--picture-card {
  border: none;
}
.bgc {
  border: 1px solid #dedede;
  background: #409eff;
  padding: 10px 20px;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.liveset {
  .alllive-list {
    .alllive-body {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #dedede;
      .live-one {
        padding: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:nth-child(1) {
          width: 5%;
        }
        &:nth-child(2) {
          width: 15%;
        }
        &:nth-child(3) {
          width: 15%;
        }
        &:nth-child(4) {
          width: 15%;
        }
        &:nth-child(5) {
          width: 15%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/liveList/attentionSet/index.vue